import React from 'react';
import MotifDatePicker from '../../../../../../components/Common/DatePicker/MotifDatePicker';
import Utility from '../../../../../../../src/util/utilityfunctions';
import Label from '../../../../../../components/Common/BaseComponentWrappers/MotifLabel';
import FormField from '../../../../../../components/Common/BaseComponentWrappers/MotifFormField';
import Input from '../../../../../../components/Common/BaseComponentWrappers/MotifInput';
import ErrorMessage from '../../../../../../components/Common/BaseComponentWrappers/MotifErrorMessage';
import {useUserPreferences} from '../../../../../../util/customHooks';

const CreateEditSampleBody = ({
    modalDescription,
    sampleLabels, 
    inputFields,
    setInputFields, 
    }) => {
    
    const userPreferences = useUserPreferences();

    const areInputsValid = (inputField) => {
		if (inputField == 'description') {
			return inputFields.hasValidation && (inputFields.description.trim().length > 500 || inputFields.description.trim() === '');
		}
		if (inputField == 'sampleDate') {
			return inputFields.hasValidation && (!inputFields.sampleDate || inputFields.sampleDate === null);
		}
	};

    return (
        <>
        <section className="modal-description">
					{modalDescription}
				</section>
				<section className="sample-description-section">
					<FormField>
						<Label position="in" htmlFor="sample-description">
							{sampleLabels.sampleDescription}
						</Label>
						<Input
							id="sample-description"
							maxLength={500}
							value={inputFields.description}
							onChange={(e) => setInputFields({
                                ...inputFields,
                                description: e.target.value || e.currentTarget.value
                            })}
						/>
						<section className="error-message-styling">
							{areInputsValid('description') && <ErrorMessage message={sampleLabels.required}/>}
						</section>
					</FormField>
				</section>
				<section className="sample-date">
					<FormField>
					<MotifDatePicker
							id="sample-date-picker"
							value={inputFields.sampleDate? new Date(inputFields.sampleDate) : null}
							onChange={(date) => setInputFields({
                                ...inputFields,
                                sampleDate: date
                            })}
							locale={Utility.getLocale(userPreferences)}
							format={Utility.getUserPreferencesDateLabel(userPreferences)}
							todayMark={true}
							yearPlaceholder="YYYY"
							dayPlaceholder="DD"
							monthPlaceholder="MM"
							label={sampleLabels.sampleDate}
						/>
						<section className="error-message-styling">
							{areInputsValid('sampleDate') && <ErrorMessage message={sampleLabels.required}/>}
						</section>
					</FormField>
				</section>
                </>
    );
};

export default CreateEditSampleBody;